import { useCallback, useEffect, useState } from "react";
import { BASE_API_URL } from "../../../Api/constants";

const INITIAL_REPORTS = {
  financialStatements: [],
  financialRatios: [],
  aiAnalysis: [],
};

export const useServicesReports = (texts) => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [reportsData, setReportsData] = useState(INITIAL_REPORTS);

  const fetchReportsData = useCallback(async () => {
    setLoading(true);
    setError(null);

    try {
      const response = await fetch(`${BASE_API_URL}client/reports`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "x-t": `Bearer ${localStorage.getItem("token")}`,
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const payload = await response.json();
      if (payload.error) {
        throw new Error(payload.message || "Failed to fetch reports");
      }

      setReportsData({
        financialStatements: payload.data?.FinancialStatements || [],
        financialRatios: payload.data?.FinancialRatios || [],
        aiAnalysis: payload.data?.AiAnalysis || [],
      });
    } catch (err) {
      console.error("Error fetching reports data:", err);
      setError(
        err.message ||
          (texts.en === "Arabic"
            ? "حدث خطأ في تحميل البيانات"
            : "Error loading data")
      );
    } finally {
      setLoading(false);
    }
  }, [texts.en]);

  useEffect(() => {
    fetchReportsData();
  }, [fetchReportsData]);

  return {
    error,
    loading,
    reportsData,
    refetch: fetchReportsData,
  };
};
